import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  constructor(private spinner: NgxSpinnerService) { }

  loadingOn() {
    this.spinner.show();
  }

  loadingOff() {
    this.spinner.hide();
  }
}
